import {useEffect, useMemo, useState} from 'react';
import {useGetLoggedInUserQuery} from "@mwServices/User";
import {SubscriptionTypes} from "@lib/constants";

const useSubscriptionType = () => {
    const loggedInQuery = useGetLoggedInUserQuery();
    const [loadedUser, setLoadedUser] = useState(loggedInQuery && loggedInQuery.data && loggedInQuery.data.user);

    const subscriptionType = useMemo<string | null>(() => loadedUser ? loadedUser.type : null, [loadedUser]);
    const isLoggedIn = useMemo(() => !!(loggedInQuery && loggedInQuery.data && loggedInQuery.data.user), [loggedInQuery]);

    const isBasic = useMemo(() => loadedUser ? loadedUser.type === SubscriptionTypes.BASIC : false, [loadedUser]);
    const isTrial = useMemo(() => loadedUser ? loadedUser.type === SubscriptionTypes.TRIAL : false, [loadedUser]);
    const isStandard = useMemo(() => loadedUser ? loadedUser.type === SubscriptionTypes.STANDARD : false, [loadedUser]);
    const isUnlimitedMonthly = useMemo(() => loadedUser ? loadedUser.type === SubscriptionTypes.UNLIMITED_MONTHLY : false, [loadedUser]);
    const isUnlimitedYearly = useMemo(() => loadedUser ? loadedUser.type === SubscriptionTypes.UNLIMITED_YEARLY : false, [loadedUser]);
    const isUnlimited = useMemo(() => isUnlimitedMonthly || isUnlimitedYearly, [isUnlimitedMonthly, isUnlimitedYearly]);
    const isUnlimitedOrTrial = useMemo(() => isUnlimited || isTrial, [isUnlimited, isTrial]);

    useEffect(() => {
        if(loggedInQuery && loggedInQuery.data && loggedInQuery.data.user){
            const user = loggedInQuery.data.user;
            if (user !== loadedUser) setLoadedUser(user);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loggedInQuery.data]);

    const testIsUpgradeFrom = (type: string) => {
        if ((isBasic || isTrial) && (
            type === SubscriptionTypes.STANDARD ||
            type === SubscriptionTypes.UNLIMITED_MONTHLY ||
            type === SubscriptionTypes.UNLIMITED_YEARLY)) return true;
        if (isStandard && (
            type === SubscriptionTypes.UNLIMITED_MONTHLY ||
            type === SubscriptionTypes.UNLIMITED_YEARLY)) return true;
        if (isUnlimitedMonthly &&
            type === SubscriptionTypes.UNLIMITED_YEARLY) return true;
        return false;
    };

    return {
        subscriptionType,
        isLoggedIn,
        isBasic,
        isTrial,
        isStandard,
        isUnlimitedMonthly,
        isUnlimitedYearly,
        isUnlimited,
        isUnlimitedOrTrial,
        testIsUpgradeFrom,
    };
}

export default useSubscriptionType;